import * as React from 'react';
import { colors } from '../../../index';

const IconLawFirm = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 55 46",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.154 41.818h31.731v2.091H21.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M51.827 39.727H22.212c-1.75 0-3.174 1.407-3.174 3.137V46H55v-3.136c0-1.73-1.424-3.137-3.173-3.137zm1.058 4.182H21.154v-1.045c0-.576.474-1.046 1.058-1.046h29.615c.584 0 1.058.47 1.058 1.046v1.045zm-27.5-17.773H27.5v3.137c-1.167 0-2.115.938-2.115 2.09v2.092c0 1.153.948 2.09 2.115 2.09h19.038c1.167 0 2.116-.937 2.116-2.09v-2.091c0-1.154-.949-2.091-2.116-2.091V12.545c1.167 0 2.116-.937 2.116-2.09V8.364c0-1.154-.949-2.091-2.116-2.091H27.5c-1.167 0-2.115.938-2.115 2.09v2.092c0 1.153.948 2.09 2.115 2.09v3.137h-2.115c-1.167 0-2.116.938-2.116 2.09H3.173C1.423 17.773 0 19.18 0 20.91s1.424 3.136 3.173 3.136H23.27c0 1.154.949 2.091 2.116 2.091zm21.153 7.319H27.5v-2.091h19.038v2.09zM27.5 8.364h19.038v2.09H27.5v-2.09zm16.923 4.181v2.091H33.846v2.091h10.577v2.091h-6.346v2.091h6.346v8.364H29.615V12.545h14.808zm-19.038 5.228H27.5v6.272h-2.115v-6.272zM3.173 21.955c-.584 0-1.058-.47-1.058-1.046 0-.576.474-1.045 1.058-1.045H23.27v2.09H3.173zm0-10.455h2.115v4.182H3.173z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.404 7.318h2.115v8.364H7.404zm4.231-2.091h2.115v10.455h-2.115zM15.865 0h2.115v15.682h-2.115z"
  })));
};

export default IconLawFirm;